import tokens from '../../design/tokens.json';

export const colors = {
  plamoBlue: tokens.shared.color.logo.blue,
  plamoBlue2: tokens.shared.color.logo.gray,
  plamoPurple: tokens.shared.color.logo.purple,
};

export const ROLE_PLAMO = 'plamo';

const localStoragePrefix = 'plamo:';
export const LS_KEY_CURRENT_PROJECT = `${localStoragePrefix}current-project`;
export const LS_KEY_AUTH_ISSUER = `${localStoragePrefix}auth-issuer`;
export const LS_KEY_TERMS_CONSENT = `${localStoragePrefix}terms-consent`;
export const SS_KEY_PENDING_LOGIN_HINT = `${localStoragePrefix}pending-login-hint`;
export const SS_KEY_SKIP_SESSION_PROBE = `${localStoragePrefix}skip-session-probe`;
